import React, { useState, useEffect } from "react";
import "./InvestmentFrequency.modules.css";
import { useTranslation } from "react-i18next";
import * as Helpers from "../../../../../global/Helpers";
import i18next from "i18next";

function InvestmentFrequency(props) {
  const { t } = useTranslation();
  const [selected, setSelected] = useState("");

  const handleClick = (value) => {
    setSelected(value);
  };

  useEffect(() => {
    if (props.IsCallAPI) saveKycDataFun();
  }, [props.IsCallAPI]);

  function validateSubmit() {
    ;
    if (props.RequestItemsList !== undefined && props.RequestItemsList !== null) {
      if (props.RequestItemsList.length >= 3)
        if (selected === null || selected === "") {
          Helpers.errorNotify(t("Please fill Investment Frequency Data"), i18next.language);
          props.setRequestItemsList([]);
          props.setIsCallAPI(false);
          return false;
        }
    }

    return true;
  }

  const saveKycDataFun = () => {
    if (!validateSubmit()) return;
    // var Items = [
    //   { ID: "173", Value: selected }
    // ]
    var arr = props.RequestItemsList;
    arr.push({ ID: "231", Value: selected });
    props.setRequestItemsList(arr);
    // props.setIsCallAPIOnce(true);
    // props.saveKycDataAPI(Items);
  };

  return (
    <div className="InvestmentFrequency-container">
      <h2>{t("InvestmentFrequency")}</h2>

      <div className="button-group">
        <button
          className={`frequency-button ${selected === "D" ? "active" : ""}`}
          onClick={(e) => {
            e.preventDefault();
            handleClick("D");
          }}>
          {t("Daily")}
        </button>
        <button
          className={`frequency-button ${selected === "M" ? "active" : ""}`}
          onClick={(e) => {
            e.preventDefault();
            handleClick("M");
          }}>
          {t("Monthly")}
        </button>
        <button
          className={`frequency-button ${selected === "O" ? "active" : ""}`}
          onClick={(e) => {
            e.preventDefault();
            handleClick("O");
          }}>
          {t("Occasionally")}
        </button>
      </div>
    </div>
  );
}

export default InvestmentFrequency;
